import { render, staticRenderFns } from "./CasualUserSettings.vue?vue&type=template&id=4db79942&"
import script from "./CasualUserSettings.vue?vue&type=script&lang=js&"
export * from "./CasualUserSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports